import { ResourcesClient } from "@/TemsManagerWebInterface"

export default class Localization {
    private static culture: string;
    private static toLocaleStringLocales: string;
    public static resourceStrings: ResourcesClient;
    public static readonly DEFAULT_CULTURE = "en-US";

    public static set Culture(culture: string) {
        if (Localization.culture !== culture) {
            Localization.culture = culture;
        }
    }

    public static get Culture(): string {
        return Localization.culture ? Localization.culture : Localization.DEFAULT_CULTURE;
    }

    public static setResourceStrings(resourceLanguages: ResourcesClient) {
        Localization.resourceStrings = resourceLanguages;
    }

    private static getDecimalSeparator(): string {
        return (1.1).toLocaleString(Localization.culture).substring(1, 2);
    }

    private static getThousandsSeparator(): string {
        let separator = (10000).toLocaleString(Localization.Culture).substring(2, 3);
        return separator !== "0" ? separator : "";
    }

    public static parseLocaleNumber(number: string): number {
        let decSeparator = Localization.getDecimalSeparator();
        let thousandsSeparator = Localization.getThousandsSeparator();
        if (thousandsSeparator !== decSeparator && thousandsSeparator !== "") {
            number = number.replace(thousandsSeparator, "");
        }

        return Number(number.replace(decSeparator, "."));
    }

    public static formatNumber3Digits(value: number) {
        return value.toLocaleString(Localization.culture, {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
            useGrouping: false
        });
    }

    public static formatNumber1Digit(value: number) {
        return value.toLocaleString(Localization.culture, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
            useGrouping: false
        });
    }

    public static formatNumberFractionDigits(value: number, digits: number, exact: boolean = false) {
        return value.toLocaleString(Localization.culture, {
            minimumFractionDigits: digits,
            maximumFractionDigits: exact ? digits : undefined,
            useGrouping: false
        });
    }

    private static messageSeveritiesLut = { // Smells like an enum...
        0: "debug",
        1: "info",
        2: "warning",
        3: "error"
    };

    public static messageSeverities(severity: number) {
        return Localization.messageSeveritiesLut[severity];
    }

    private static healthStates = {
        Good: "success",
        Moderate: "warning",
        Bad: "danger"
    };

    public static translateHealth(healthState) {
        return Localization.healthStates[healthState] || "default";
    }

    public static isoDateTimeToLocal(isoDateTime: string): string {
        return new Date(isoDateTime).toLocaleString(Localization.culture);
    }

    public static tryParseDate(date: string): Date {
        const parsed: number = Date.parse(date);
        return !isNaN(parsed) ? new Date(parsed) : undefined;
    }

    // TODO should be in another class...
    public static compareCollections(oldArray: any[], newArray: any[], idSelector) {
        var oldIds = oldArray ? oldArray.map(idSelector) : [];
        var newIds = newArray ? newArray.map(idSelector) : [];

        var removed = [];
        var same = [];

        for (var i = 0, oiLen = oldIds.length; i < oiLen; i++) {
            var id = oldIds[i];
            var newIdsIndex = $.inArray(id, newIds);
            if (newIdsIndex === -1) {
                removed.push(id);
            } else {
                same.push(id);
                newIds.splice(newIdsIndex, 1);
            }
        }

        return {
            added: newIds,
            removed: removed,
            same: same
        };
    }
}